import { useCallback } from "react";
import { usePrefetchedBrandedFaresOffer, useSearchResultOffer } from "../../hooks/useSearchResults.js";
import useBrandedFares from "../../branded-fares/hooks/useBrandedFares.js";
import useTrackFlightsWebUseOfferPos from "../../hooks/useTrackFlightsWebUseOfferPosExp.js";
import { getMarketingTrackingVariable, isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import { isDeltaAirlinesOffer } from "../../components/elements/FlightCard/utils.js";
import useAlternativeFaresParams from "../../hooks/useAlternativeFaresParams.js";
import useGlobalContext from "../../hooks/useGlobalContext.js";
export function useFlightDetailsDesktopApiUrl(params) {
    const { features } = useGlobalContext();
    const flightOffer = useSearchResultOffer(params?.id);
    const brandedFareOffers = useBrandedFares(params?.id);
    const flightsWebUseOfferPos = useTrackFlightsWebUseOfferPos();
    const prefetchedbrandedFareOffer = usePrefetchedBrandedFaresOffer(params?.id);
    const shouldForwardBaseOfferToken = features["FLIGHTS_WEB_FD_FORWARD_BASE_OFFER_TOKEN"];
    const { setAlternativeFaresParams } = useAlternativeFaresParams();
    const isDelta = isFeatureRunningClientSide("FLIGHTS_DELTA_DONT_SKIP_FETCH_BRANDED_FARES") &&
        flightOffer &&
        isDeltaAirlinesOffer(flightOffer);
    const hasPrefetchedBrandedFareOffers = !!((flightOffer &&
        !isDelta &&
        !flightOffer.requestableBrandedFares &&
        !prefetchedbrandedFareOffer &&
        brandedFareOffers.brandedFareOffers?.length) ||
        prefetchedbrandedFareOffer);
    const generateApiUrl = useCallback((urlParams, searchParams) => {
        if (hasPrefetchedBrandedFareOffers) {
            searchParams.set("hasPrefetchedBrandedFareOffers", "true");
        }
        const requestableBrandedFares = flightOffer?.requestableBrandedFares;
        const shouldSkipBrandedFares = flightOffer && !isDelta && !requestableBrandedFares;
        if (shouldSkipBrandedFares) {
            searchParams.set("skipBrandedFares", "1");
        }
        if (flightsWebUseOfferPos.isVariant) {
            const salesCountry = getMarketingTrackingVariable("salesCountry");
            if (salesCountry) {
                searchParams.set("salesCountry", salesCountry);
                setAlternativeFaresParams("salesCountry", salesCountry);
            }
        }
        const brandedFareIndex = urlParams.get("brandedFareIndex");
        const baseOfferToken = urlParams.get("baseOfferToken");
        const caSource = urlParams.get("ca_source");
        const caPrice = urlParams.get("ca_price");
        const source = urlParams.get("source");
        if (caSource)
            searchParams.set("ca_source", caSource);
        if (caPrice)
            searchParams.set("ca_price", caPrice);
        if (brandedFareIndex)
            searchParams.set("brandedFareIndex", brandedFareIndex);
        if (shouldForwardBaseOfferToken && baseOfferToken)
            searchParams.set("baseOfferToken", baseOfferToken);
        if (source)
            searchParams.set("source", source);
        return `/api/flight/${params?.id}?${searchParams.toString()}`;
    }, [
        params?.id,
        flightOffer,
        isDelta,
        hasPrefetchedBrandedFareOffers,
        flightsWebUseOfferPos.isVariant,
        shouldForwardBaseOfferToken,
        setAlternativeFaresParams
    ]);
    return {
        generateApiUrl,
        hasPrefetchedBrandedFareOffers
    };
}
